module.exports = __webpack_public_path__ + "media/components/src/assets/images/method/apple-pay-9df3111b4366c26c5377e591ff66b59f.svg";